module.exports = __webpack_public_path__ + "static/step1-0f85d5e008ca02916ed27a399ff8961f.svg";